import {useState, useEffect} from 'react';
import api from '../../../config.js';
import './people.css';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaEye, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { getPermission, showMessageError } from '../../../classes/functions';
import { Link } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import HeaderListing from '../../../components/HeaderListing/index.js';

export default function People(){
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limitPage, setLimitPage] = useState(1);
  const [itensByPage, setItensByPage] = useState(50);
  const [carrying, setCarrying] = useState(true);

  function getPeople(){
    let param = `page=${page}&limit=${itensByPage}&search=${search}`;

    api
    .get(`/api/people/getList?${param}`)
    .then((response) => {
      setList(response.data.row);
      setLimitPage(parseInt(response.data.total / itensByPage) + 1);

      setCarrying(false);
    })
    .catch((error) => {
      setCarrying(false);
      console.log(error);
      showMessageError(error.response.data);
    });
  }

  useEffect(() => {
    getPeople();
  }, [, page, itensByPage, search]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      <HeaderListing name="Pessoas" url="/people/cadastrar" permission="CADASTROS - PESSOAS - CADASTRO" carrying={carrying} search={search} itensByPage={itensByPage} setItensByPage={setItensByPage} termSearch={search} setTermSearch={setSearch} pesquisa_status={search}>
        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">CPF/CNPJ</th>
                <th scope="col">Razão Social</th>
                <th scope="col">Nome Fantasia</th>
                <th scope="col">Arquetipo</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Tipo">{item.tipo}</td>
                    <td data-label="CPF/CNPJ">{item.cgc}</td>
                    <td data-label="Razão Social">{item.razao_social}</td>
                    <td data-label="Nome Fantasia">{item.nome_fantasia}</td>
                    <td data-label="Arquetipo">{item.arquetipo}</td>
                    <td data-label="Opções">
                      {getPermission('CADASTROS - PESSOAS - CADASTRO') && <Link className="action" to={`/people/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} />
                      </Link>}
                      <Link className="action" to={`/people/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} />
                      </Link>
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={6}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <div className="divGroupPagination">
          <button data-tip="Primeira página" type="button" onClick={() => setPage(1)} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
          <button data-tip="Página anterior" type="button" onClick={() => setPage(page > 1 ? page - 1 : 1)} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
          <div className="divLabelPagination">
            <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
          </div>
          <button data-tip="Próxima página" type="button" onClick={() => setPage((page + 1) < limitPage ? page + 1 : limitPage)} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
          <button data-tip="Última página" type="button" onClick={() => setPage(limitPage)} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
        </div>
      </HeaderListing>
    </div>
  )
}